import { isType } from './types.js';
import { dynamicArraySize, isDynamicArray } from './fields.internal.js';
export function isStructInstance(arg) {
    return (typeof arg == 'object' && arg !== null && 'constructor' in arg && isStructConstructor(arg.constructor));
}
export function isStructConstructor(arg) {
    return (typeof arg == 'function'
        && 'prototype' in arg
        && 'fields' in arg
        && typeof arg.fields == 'object'
        && isType(arg));
}
/**
 * Gets the dynamic size in bytes of a struct instance.
 * This *does not* include the static size of the struct.
 */
export function dynamicStructSize(instance) {
    let size = 0;
    for (const field of instance.constructor.fields) {
        const value = instance[field.name];
        if (isDynamicArray(instance, field)) {
            size += dynamicArraySize(instance, field);
        }
        if (isStructInstance(value) && value.constructor.isDynamic) {
            size += dynamicStructSize(value);
        }
    }
    return size;
}
